import { render, staticRenderFns } from "./pif1-5-4.html?vue&type=template&id=1ee13398&"
import script from "./PIF1-5-4.vue?vue&type=script&lang=js&"
export * from "./PIF1-5-4.vue?vue&type=script&lang=js&"
import style0 from "./PIF1-5-4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports